module.exports = __webpack_public_path__ + "entry-150bfe9b/banner-6c6aa1c3f49acfec9c9c53cf3653763a.svg";